import React from "react";
import map from "lodash/map";
import get from "lodash/get";
import { CellProps } from "components/table/Table";
import PouchSelect from "components/PouchSelect";
import SortableHeaderCell from "components/SortableHeaderCell";

const DivisionCell = ({
  data,
  column,
  meet,
  style,
  getInnerCellAriaLabel,
}: CellProps) => {
  const lifter = data;
  if (lifter.row === "header") {
    return <SortableHeaderCell style={style} column={column} />;
  } else {
    return (
      <div style={style} className="table-cell-inner">
        {map(lifter.divisions, (division, index: number) => {
          if (!column.options) {
            return null;
          }
          return (
            <div key={index} className="inner-row">
              <PouchSelect
                key={index}
                index={index}
                meet={meet}
                document={lifter}
                name={["divisions", index, column.key]}
                value={get(lifter, ["divisions", index, column.key])}
                options={column.options}
                clearable
                ariaLabel={
                  getInnerCellAriaLabel
                    ? `${getInnerCellAriaLabel({ data, column })} Division ${index + 1}`
                    : undefined
                }
              />
            </div>
          );
        })}
      </div>
    );
  }
};

export default DivisionCell;
